module.exports = __webpack_public_path__ + "media/img/event/academy-bottom-banner-3b384bfb8c5d435e42a521e93e58d3ce.jpeg";